import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import WorkSwiper from '../../work-swiper/work-swiper';
import Heading from '../../heading/heading';

const WorkSwiperBlock = ({ paddingTop, paddingBottom, heading, ...props }) => {
  console.log(props);
  return (
    <div id={"work"}>
    <Spacing pt={paddingTop} pb={paddingBottom}>
      <Container size={'lg'} gutters>
        <Spacing pt={0} pb={2}>
          <Heading tag={2} text={heading} size={'lg'} animate />
        </Spacing>
      </Container>
      <Container size={'xl'} gutters paddingNoneMobile>
        <WorkSwiper {...props} name={props.__typename} />
      </Container>
    </Spacing>
    </div>
  );
};

export default WorkSwiperBlock;

export const query = graphql`
  fragment WorkSwiperBlock on DatoCmsWorkSwiperBlock {
    id: originalId
    paddingTop
    paddingBottom
    heading
    items {
      url
      thumbnail {
        gatsbyImageData(
          layout: FULL_WIDTH
          imgixParams: { fit: "crop", w: "2000", h: "1250" }
        )
      }
    }
    __typename
  }
`;
